/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, useContext } from 'react';
import { FormattedMessage } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withModalContext } from '@jutro/components';
import { MLGatewayAccountBillingDetailsService } from 'gw-capability-gateway-billing';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import {
    MLSelectPolicyToPayComponent,
    MLSelectPaymentAmountComponent,
    MLSelectPaymentMethodComponent,
    MLBankAccountDetailsComponent,
    MLAgencySweepComponent,
    MLScriptComponent,
    MLCreditCardDetailsComponent
} from 'ml-components-common-react';
import { PolicyService } from 'gw-capability-gateway';
import { MLPaymentService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLModalService, MLTagManagerService, AskServiceOpsService } from 'ml-portals-services-react';
import {FormModalPopover, platformMessages} from 'ml-components-platform-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLBillingUtil } from 'ml-portals-util-react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';

import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import appConfig from 'app-config';
import metadata from './MLAccountBilling.metadata.json5';
import styles from './MLAccountBilling.module.scss';
import messages from './MLAccountBilling.messages';

import { Button } from '@jutro/legacy/components';

import { IntlContext, TranslatorContext } from '@jutro/legacy/locale';

// ==================== Constants (START) ==================== //
const BOA_BANK_NAME = 'boa';
const BANK_REFRESH_DELAY = 1000;
const CC_REFRESH_DELAY = 750;

const DL_ACTIONS = {
    ADD_ACOUNT: 'addAccount',
    CANCEL: 'cancel',
    EDIT_ACCOUNT: 'editAccount'
};

const PAYMENT_METHODS = {
    CREDIT_CARD: 'creditcard',
    BANK_ACCOUNT: 'ach',
    AGENCY_SWEEP: 'agencysweep'
};

const ACCORDION_CARDS = {
    SELECT_POLICY: 'selectPolicyCard',
    PAYMENT_AMOUNT: 'paymentAmountCard',
    PAYMENT_METHOD: 'paymentMethodCard'
};

const PAYMENT_CHANNELS = {
    AGENT_PHONE: 'AgentPhone',
    CUSTOMER_PORTAL: 'CustomerPortal',
    AGENT_IN_PERSON: 'AgentInPerson',
    AGENT: 'Agent',
    CUSTOMER_SERVICE: 'CustomerService',
    AGENCY_SWEEP: 'AgencySweep'
};

const AMOUNT_OPTIONS = {
    OTHER_AMOUNT: 'other-amount'
};
const NON_PREFERRED_PAYMENT_METHODS = ['VISA', 'MC', 'AMEX', 'DISC'];

const { MLUserTypes, MLJpmcResponsePath, MLProducerTypes, mercerOrganization } = appConfig;

const {
    showErrorModal,
    showProgressDialog,
    hideProgressDialog
} = MLModalService();

const {
    getPreviousTermsWithRemainingBalance,
    getPreviousTermsWithOutstandingBalance
} = MLBillingUtil();

const intl = useContext(IntlContext);

const askSoService = AskServiceOpsService();

const { authUserData } = useAuthentication();

// account/BillingCtrl.js, billing.html
class MLAccountBillingWithoutModalContext extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,

        authenticated: PropTypes.bool.isRequired,
        authHeader: PropTypes.shape({}).isRequired
    };

    constructor(props) {
        super(props);

        const { viewModelService } = props;
        const bundledPaymentRequestData = {
            paymentRequests: []
        };

        this.state = {
            accountNumber: null,
            billingDatas: [],
            currentCard: ACCORDION_CARDS.SELECT_POLICY,
            accountBillingData: undefined,
            policySummaries: undefined,
            setHasPaymentInstrumentStatus: true,
            paymentInstruments: null,
            paymentError: { paymentProcessingError: false, invalidCreditCardError: false, lessThanMinCardAmountError: false },
            paymentDeclinedReason: null,
            bankAccountDetails: viewModelService.create({}, 'pc', 'metlife.edge.capabilities.policyjob.binding.dto.BankAccountDetailsDTOML'),
            agencySweepInfo: viewModelService.create({}, 'pc', 'metlife.edge.capabilities.user.group.dto.AgencySweepInfoDTOML'),
            bundledPaymentRequest: viewModelService.create(bundledPaymentRequestData, 'pc', 'metlife.edge.capabilities.policycommon.paymentdetails.dto.BundledPaymentRequestDTOML'),
            selectedPolicy: viewModelService.create({}, 'pc', 'edge.capabilities.gateway.policy.dto.PolicySummaryDTO'),
            confirmation: {},
            sweepPaymentDetails: viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.binding.dto.PaymentDetailsDTO'),
            paymentInstrumentsForAllPolicies: null,
            scriptML: null,
            isAgentScripts: authUserData ? (authUserData.userType === MLUserTypes.GCS_SALES || authUserData.userType === MLUserTypes.GCS_SERVICING|| authUserData.userType === MLUserTypes.MET_GA) : false,
            isChecked: false,
            showDownpaymentScriptCheckbox: false,
            showPaymentInstruments: false,
            showPaymentusIframe: false,
            showBankAccountDetails: false,
            showAgencySweepDetails: false,
            selectedAmountOption: { value: null },
            selectedPaymentMethod: { value: null },
            selectedPaymentInstrument: { value: null },
            selectedPaymentChannel: viewModelService.create({}, 'pc', 'metlife.edge.capabilities.policycommon.paymentdetails.dto.PaymentRequestDTOML').paymentChannel_ML,
            pendingPaymentPolicies: new Set(),
            deletedPaymentInstrument: undefined,
            paymentDetailsUrl: '',
            isLoading: true,
            refresh: false,
            usePaymentusAch: true,
            enableBundledOneStepPayments: false,
            showRestrictedPaymentMethodError: false,
            showRestrictedPaymentMethodWarning: false
        };

    }

    goToSelectedAccordion = (thisCard) => {
        this.setState({ currentCard: thisCard });
    };

    refreshData = () => {
        this.setState((prevState) => ({ refresh: !prevState.refresh }));
    };

    formatAmountString = (amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');
        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    };

    isMetGaUser = () => {
        return (this.props.authUserData.userType === MLUserTypes.PCS
            && this.props.authUserData.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA)
            || this.props.authUserData.userType === MLUserTypes.MET_GA;
    };

    isGcsUser = () => {
        return this.props.authUserData.userType === MLUserTypes.GCS_SALES || this.props.authUserData.userType === MLUserTypes.GCS_SERVICING;
    };

    isGscSalesAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.GCS_SALES;
    };

    isGscServiceAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.GCS_SERVICING;
    };

    isPCSAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.PCS;
    };

    isIAAgent = () => {
        return this.props.authUserData.userType === MLUserTypes.IA;
    };

    isMercerAgent = () => {
        return this.props.authUserData?.primaryProducerCode_ML?.organization_ML.name?.toLowerCase()?.includes(mercerOrganization);
    };

    isSplUser = () => {
        return !this.isMercerAgent() && (this.isGcsUser() || this.isMetGaUser());
    };

    updateCheckboxValue = (value) => {
        this.setState({ isChecked: value });
    };

    showCheckbox = () => {
        return this.state.showDownpaymentScriptCheckbox;
    };

    showScript = () => {
        return !!this.state.scriptML && this.state.isAgentScripts && this.isSelectedPaymentInstrumentValid();
    }

    loadCurrentTermWithRemainingBalanceAmount = (terms, currentTerm) => {
        const previousTermsWithRemainingBalance = getPreviousTermsWithRemainingBalance(terms);
        if (previousTermsWithRemainingBalance.length > 0) {
            currentTerm.previousTermsRemainingAmounts = 0;
            previousTermsWithRemainingBalance.forEach((term) => {
                currentTerm.previousTermsRemainingAmounts += term.remainingPolicyBalance_ML.amount;
            });
        }
    };

    loadCurrentTermWithOutstandingBalanceAmount = (terms, currentTerm) => {
        const previousTermsWithOutstandingBalance = getPreviousTermsWithOutstandingBalance(terms);
        if (previousTermsWithOutstandingBalance.length > 0) {
            currentTerm.previousTermsOutstandingAmounts = 0;
            previousTermsWithOutstandingBalance.forEach((term) => {
                currentTerm.previousTermsOutstandingAmounts += term.totalOutstandingAmount_ML.amount;
            });
        }
    };

    filterBillingData = (billingData) => {
        const billingDataPerPolicy = [];
        this.setState({ billingDatas: billingData });

        billingData.forEach((data) => {
            const dataToCompare = billingData.filter((d) => d.policyID_ML === data.policyID_ML);
            const currentTerm = dataToCompare[dataToCompare.length - 1];
            if (billingDataPerPolicy.length === 0) {
                // only display last term of a selectable policy
                this.loadCurrentTermWithRemainingBalanceAmount(dataToCompare, currentTerm);
                this.loadCurrentTermWithOutstandingBalanceAmount(dataToCompare, currentTerm);
                billingDataPerPolicy.push(dataToCompare[dataToCompare.length - 1]);
            } else if (!billingDataPerPolicy.find((d) => d.policyID_ML === data.policyID_ML)) {
                // only display last term of a selectable policy
                this.loadCurrentTermWithRemainingBalanceAmount(dataToCompare, currentTerm);
                this.loadCurrentTermWithOutstandingBalanceAmount(dataToCompare, currentTerm);
                billingDataPerPolicy.push(dataToCompare[dataToCompare.length - 1]);
            }
        });

        return billingDataPerPolicy;
    };

    // initialize or reset payment channel
    setPaymentChannel = () => {
        let paymentChannel = PAYMENT_CHANNELS.AGENT;
        if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT) {
            paymentChannel = PAYMENT_CHANNELS.CUSTOMER_SERVICE;
        }

        if (this.isGscServiceAgent()) {
            paymentChannel = PAYMENT_CHANNELS.CUSTOMER_SERVICE;
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.AGENCY_SWEEP) {
            paymentChannel = PAYMENT_CHANNELS.AGENCY_SWEEP;
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD) {
            paymentChannel = PAYMENT_CHANNELS.AGENT;
        } else if ((this.isGscSalesAgent() || this.isMetGaUser()) && this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT) {
            paymentChannel = PAYMENT_CHANNELS.CUSTOMER_SERVICE;
        } else if (this.isPaymentChannelRequired()) {
            paymentChannel = this.state.selectedPaymentChannel.code;
        }

        this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
            item.paymentChannel_ML = paymentChannel;
        });
    };

    getPaymentInstrumentsForAllPolicies = (accountNumber) => {
        const instrumentsPromise = MLPaymentService.getPolicyPaymentInstrumentsForAccount(accountNumber, true, this.props.authHeader);
        instrumentsPromise.then((instruments) => {
            this.state.paymentInstrumentsForAllPolicies = instruments;
        });
    };

    isPaymentChannelRequired = () => {
        return this.isShowAgentPaymentChannel() && this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT;
    };

    isShowOneTimePaymentNext = () => {
        return this.isPaymentChannelRequired() && this.state.selectedPaymentChannel.code === PAYMENT_CHANNELS.AGENT_IN_PERSON;
    };

    hasPaymentError = () => {
        return this.state.paymentError.paymentProcessingError || this.state.paymentError.invalidCreditCardError || this.state.paymentError.lessThanMinCardAmountError;
    };

    isShowAgentPaymentChannel = () => {
        return this.isPCSAgent() || this.isIAAgent();
    };

    isValidSelectedPaymentAmount = (selectedAmount, totalBalance) => {
        if (selectedAmount) {
            const { amount } = selectedAmount;
            return amount >= 1 && amount <= totalBalance;
        }
        return false;
    };

    isChildComponentValid = (card) => {
        const paymentRequests = this.state.bundledPaymentRequest.paymentRequests.value;
        if (card === ACCORDION_CARDS.PAYMENT_AMOUNT && this.state.selectedAmountOption.value === AMOUNT_OPTIONS.OTHER_AMOUNT) {
            return !_.find(paymentRequests, (paymentRequest) => {
                const selectedAmount = paymentRequest.selectedAmount;
                return !this.isValidSelectedPaymentAmount(selectedAmount, paymentRequest.policyBalance);
            });
        }
        return true;
    };

    // Payment Start
    getPaymentInstruments = (accountNumber) => {
        askSoService.storeCurrentPageData(this.props.accountInfo.primaryAddress.state, '', '', '');
        return MLGatewayAccountBillingDetailsService.getPaymentInstrumentsForAccount(accountNumber, this.props.authHeader);
    };

    filterPaymentInstrumentsByMethod = (paymentInstrument) => {
        if (paymentInstrument) {
            return paymentInstrument.paymentMethod === this.state.selectedPaymentMethod.value && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === PAYMENT_METHODS.CREDIT_CARD);
        }
        return false;
    };

    hasPaymentInstrumentsForMethod = () => {
        let hasPaymentInstruments = false;

        this.state.paymentInstruments.forEach((paymentInstrument) => {
            if (this.filterPaymentInstrumentsByMethod(paymentInstrument)) {
                hasPaymentInstruments = true;
            }
        });

        return hasPaymentInstruments;
    };

    goToPaymentInstruments = (keepSelectedPaymentInstrument) => {
        this.resetPaymentInstrument(keepSelectedPaymentInstrument);
        const _showPaymentInstruments = this.isSplUser() ? true : (this.state.usePaymentusAch && this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT)
            || this.hasPaymentInstrumentsForMethod() || this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD;
        this.setState({
            showPaymentInstruments: _showPaymentInstruments
        });
        if (!_showPaymentInstruments) {
            this.goToPaymentInstrumentDetails(true);
        }
    };

    defaultPaymentInstrument = (paymentMethod) => {
        let requiresPreferredPaymentMethod = false;
        const paymentRequests = this.state.bundledPaymentRequest.paymentRequests.value;
        paymentRequests.forEach((request) => {
            if (request.isModernProduct_Ext && request.preferredPaymentMethodInd_Ext) {
                requiresPreferredPaymentMethod = true;
            }
        });

        if (this.isSplUser() && (paymentMethod === PAYMENT_METHODS.CREDIT_CARD ||
            (paymentMethod === PAYMENT_METHODS.BANK_ACCOUNT))) {
            this.state.selectedPaymentInstrument.value = null;
            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                item.selectedPaymentInstrument_ML = null;
            });
        } else {
            const getFirstPaymentInstrument = (type) => {
                let paymentInstruments = this.state.paymentInstruments.filter((instrument) =>
                    instrument.paymentMethod === type && (instrument.portalAvailable !== false || type === PAYMENT_METHODS.CREDIT_CARD))
                    .sort((a, b) => a.last4Digits - b.last4Digits);
                if (requiresPreferredPaymentMethod) {
                    paymentInstruments = paymentInstruments.filter((instrument) =>
                        !NON_PREFERRED_PAYMENT_METHODS.includes(instrument.accountType_ML)
                    )
                }
                if (paymentInstruments.length > 0) {
                    return paymentInstruments[0];
                }
                return null;
            };

            this.state.selectedPaymentInstrument.value = getFirstPaymentInstrument(paymentMethod);
            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                item.selectedPaymentInstrument_ML = this.state.selectedPaymentInstrument.value.token;
            });
        }
    };

    setSelectedPaymentInstrument = (instruments, token) => {
        const paymentInstrument = instruments.find((instrument) => instrument.token === token);
        if (!_.isUndefined(paymentInstrument)) {
            this.state.selectedPaymentInstrument.value = paymentInstrument;
            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                item.selectedPaymentInstrument_ML = paymentInstrument.token;
            });
        }
    };

    areMultiplePoliciesSelected = () => {
        return this.state.accountBillingData.filter((c) => c.selected).length > 1;
    };

    resetPaymentInstrument = (keepSelectedPaymentInstrument = false) => {
        this.state.showPaymentusIframe = false;
        this.state.showBankAccountDetails = false;
        this.state.showAgencySweepDetails = false;
        this.state.selectedPaymentInstrument = { value: null };
        if (!keepSelectedPaymentInstrument) {
            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                item.selectedPaymentInstrument_ML = null;
            });
        }
    };

    resetPaymentError = () => {
        this.state.paymentError = { paymentProcessingError: false, invalidCreditCardError: false, lessThanMinCardAmountError: false };
        this.state.paymentDeclinedReason = null;
    };

    addPaymentInstrument = () => {
        this.goToPaymentInstrumentDetails(true);
        this.refreshData();
    }

    getNewPaymentInstrumentFromList = (oldInstrumentList, newInstrumentList) => {
        const existingPaymentInstrumentList = oldInstrumentList.filter((instrument) => instrument.paymentMethod === this.state.selectedPaymentMethod.value).map((instr) => instr.token);
        const newPaymentInstrumentList = newInstrumentList.filter((instr) => instr.paymentMethod === this.state.selectedPaymentMethod.value);
        if (newPaymentInstrumentList.length > existingPaymentInstrumentList.length) {
            return newInstrumentList.find((instrument) => instrument.paymentMethod === this.state.selectedPaymentMethod.value && !existingPaymentInstrumentList.includes(instrument.token));
        }
        return null;
    }

    getCardDownpaymentScript = (payment) => {
        if (typeof payment === 'string') {
            payment = payment.replace(/^0+/, '');
        }
        if (this.state.isAgentScripts) {
            const lines = ['<p><b>The following must be read verbatim to the caller:</b><br>Do you certify that you are an owner or authorized user of this card?</p>',
                `<p><b>Affirmative Answer Needed:</b><br>By providing your credit or debit card information today, you are authorizing us to process the transaction through our vendor. Do you agree to these terms and conditions and authorize me to process the transaction for $${payment}?</p>`,
                '<b>You must hear an affirmative response on both questions before clicking Make Payment.</b>'];
            this.state.scriptML = lines;
        }
    };

    getAccountDownpaymentScript = (payment, last4Account) => {
        if (this.state.isAgentScripts) {
            const lines = [`<p><b>The following must be read verbatim to the caller:</b><br>Do you certify that you are an owner or signer for the account number ending in ****${ last4Account }?</p>`,
                `<p><b>Affirmative Answer Needed:</b><br>When we take your checking or savings account information today, you are authorizing us to process a one time electronic withdrawal from your account. If this withdrawal is rejected by the bank, such as due to insufficient funds, it may be resubmitted. Do you agree to these terms and conditions and authorize me to process the transaction for $${payment}?</p>`,
                '<b>You must hear an affirmative response on both questions before clicking Make Payment.</b>'];
            this.state.scriptML = lines;
        }
    };

    goToPaymentInstrumentDetails = (addNewPaymentInstrument = false) => {
        let saveFlag = false;
        const updateSaveFlag = (val) => {
            saveFlag = val;
        };

        const getPaymentInstrumentUrl = (authHeader) => {
            const translator = this.context;
            const oldInstrumentList = this.state.paymentInstruments;
            let promiseForIframeUrl = null;
            let isSplMakePayment = false;
            let hideSaveAccountCheckbox = false;
            let preferredPaymentMethodRequired = false;

            const paymentRequests = this.state.bundledPaymentRequest.paymentRequests.value;
            paymentRequests.forEach((request) => {
                if (request.isModernProduct_Ext && request.preferredPaymentMethodInd_Ext) {
                    preferredPaymentMethodRequired = true;
                }
            });

            if (this.isSplUser() && (!this.areMultiplePoliciesSelected() || this.state.enableBundledOneStepPayments)) {
                isSplMakePayment = true;
                this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                    item.isSecurePayLinePayment = true;
                });
                promiseForIframeUrl = MLGatewayAccountBillingDetailsService.getSplMakePaymentUrl(
                    this.state.accountNumber,
                    this.state.selectedPaymentMethod.value,
                    this.state.bundledPaymentRequest.value,
                    authHeader
                );
            } else {
                if (this.isSplUser()) {
                    hideSaveAccountCheckbox = true;
                }
                promiseForIframeUrl = MLGatewayAccountBillingDetailsService.getNewPaymentInstrumentUrl(
                    this.state.accountNumber,
                    this.state.selectedPaymentMethod.value,
                    `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
                    preferredPaymentMethodRequired,
                    this.isSplUser(),
                    authHeader
                );
            }

            showProgressDialog(platformMessages.loading, promiseForIframeUrl);

            promiseForIframeUrl.then((iframeUrl) => {
                this.state.showPaymentInstruments = true;
                this.state.selectedPaymentInstrument.value = null;
                this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                    item.selectedPaymentInstrument_ML = null;
                });
                const modalTitle = this.state.bundledPaymentRequest.paymentRequests.value.length > 1 ? translator(messages.addNewAccount) : translator(messages.makePayment);
                const componentProps = {
                    title: modalTitle,
                    CustomComponent: MLCreditCardDetailsComponent,
                    additionalPEStyle: 'customPaymentModal',
                    overrideProps: {
                        jpmcURL: iframeUrl,
                        gpaMode: true,
                        iframeHeight: isSplMakePayment ? '975px' : '600px',
                        iframeWidth: isSplMakePayment ? '1100px' : '700px',
                        isDownPaymentInstrument: false,
                        isSplMakePayment,
                        hideSaveAccountCheckbox,
                        refreshAccountList: this.refreshAccountsList,
                        refreshData: this.refreshData,
                        markCreditCardForDeletion: this.markCreditCardForDeletion,
                        isSplUser: this.isSplUser,
                        setSaveCreditCard: updateSaveFlag,
                        instrumentType: 'onetimepayment',
                        setSelectedPaymentInstrument: this.setSelectedPaymentInstrument
                    }
                };

                this.props.modalContext.showModal(
                    <FormModalPopover {...componentProps} />
                ).catch(() => {
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                        item.selectedPaymentInstrument_ML = null;
                        item.isSecurePayLinePayment = false;
                    });
                    const promiseForPayInsts = this.getPaymentInstruments(this.state.accountNumber);
                    showProgressDialog(platformMessages.loading, promiseForPayInsts);
                    promiseForPayInsts.then((pms) => {
                        let instruments = [];
                        if (this.state.usePaymentusAch) {
                            instruments = instruments.concat(pms);
                        } else {
                            if (pms[0]) {
                                instruments = instruments.concat(pms[0]);
                            }
                            if (pms[1]) {
                                instruments = instruments.concat(pms[1]);
                            }
                        }
                        instruments.forEach((paymentInstrument) => {
                            paymentInstrument.isOnPaymentPage = true;
                        });
                        const newPaymentInstrument = this.getNewPaymentInstrumentFromList(oldInstrumentList, instruments);
                        if (newPaymentInstrument && !isSplMakePayment) {
                            if (!saveFlag) {
                                this.markCreditCardForDeletion(newPaymentInstrument.token);
                            }
                            this.state.selectedPaymentInstrument.value = newPaymentInstrument;
                            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                                item.selectedPaymentInstrument_ML = newPaymentInstrument.token;
                            });
                            if (newPaymentInstrument.paymentMethod === 'creditcard' && this.state.isAgentScripts) {
                                this.getCardDownpaymentScript(this.getTotalPaidAmount().amount);
                                this.state.showDownpaymentScriptCheckbox = true;
                            } else if (newPaymentInstrument.paymentMethod === 'ach' && this.state.isAgentScripts) {
                                this.getAccountDownpaymentScript(this.getTotalPaidAmount().amount, this.state.selectedPaymentInstrument?.value?.last4Digits);
                                this.state.showDownpaymentScriptCheckbox = true;
                            }
                        }
                        this.setState({paymentInstruments: instruments});
                    }).catch((error) => {
                        console.log(error);
                    });
                }).catch((error) => {
                    console.log(error);
                });
            });
        };

        this.state.showPaymentInstruments = false;
        if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD ||
            (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT && this.state.usePaymentusAch)) {
            if (addNewPaymentInstrument) {
                getPaymentInstrumentUrl(this.props.authHeader);
            }
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT && !this.state.usePaymentusAch) {
            this.state.showBankAccountDetails = true;
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.AGENCY_SWEEP) {
            this.state.showAgencySweepDetails = true;
        }
    };

    showBankAccountOption = () => {
        let showBankOption = true;
        if (this.state.accountBillingData) {
            this.state.accountBillingData.forEach((policy) => {
                if (policy.selected && (policy.hasTwoOrMoreACHPaymentReversals_ML || policy.hasLouisianaStopFile_Ext)) {
                    this.state.showBankAccountDetails = false;
                    showBankOption = false;
                }
            });
        }
        return showBankOption;
    };

    showAgencySweepOption = () => {
        return _.get(this.state.selectedPolicy.value, 'producerCodeOfServiceSweepInfo_ML.agencySweepIndicator', false);
    };

    last4Digits = (accountNumber) => {
        return accountNumber.length > 3 ? accountNumber.substr(accountNumber.length - 4) : accountNumber;
    };

    getTotalPaidAmount = () => {
        const total = {
            amount: 0,
            currency: 'usd'
        };
        this.state.bundledPaymentRequest.paymentRequests.value.forEach((paymentRequest) => {
            total.amount += parseFloat(paymentRequest.paymentAmount);
        });
        total.amount = total.amount.toFixed(2);
        return total;
    };

    isSelectedPaymentInstrumentValid = () => {
        if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.AGENCY_SWEEP) {
            return this.state.sweepPaymentDetails?.customerPaymentMethod_ML?.value !== undefined;
        }
        if (this.state.selectedPaymentInstrument && this.state.selectedPaymentInstrument.value && this.state.selectedPaymentInstrument.value.token) {
            return this.state.paymentInstruments && this.state.paymentInstruments.findIndex((instrument) => {
                return instrument.token === this.state.selectedPaymentInstrument.value.token
                    && ((instrument.paymentMethod === 'ach' && instrument.portalAvailable === true) || instrument.paymentMethod === 'creditcard')
                    && instrument.paymentMethod === this.state.selectedPaymentMethod.value;
            }) > -1;
        }
        return false;
    };

    isMakePaymentValid = () => {
        const hasErrors = this.state.paymentError.invalidCreditCardError || this.state.paymentError.lessThanMinCardAmountError;
        if (!this.isSelectedPaymentInstrumentValid()) {
            return false;
        }
        return this.state.bundledPaymentRequest.aspects.subtreeValid && !hasErrors;
    };

    refreshPaymentInstruments = (keepSelectedPaymentInstrument) => {
        const promiseForBoAPaymentInsts = MLGatewayAccountBillingDetailsService.getBoAPaymentInstrumentsForAccount(this.state.accountNumber, this.props.authHeader).catch((e) => console.error(e));
        const promiseForCreditCardPaymentInsts = MLGatewayAccountBillingDetailsService.getCCPaymentInstrumentsForAccount(this.state.accountNumber, this.props.authHeader).catch((e) => console.error(e));
        const promiseForPayInsts = Promise.all([promiseForBoAPaymentInsts, promiseForCreditCardPaymentInsts]);
        showProgressDialog(platformMessages.loading, promiseForPayInsts);
        promiseForPayInsts.then((paymentInstruments) => {
            this.state.paymentInstruments = paymentInstruments[0] ? paymentInstruments[0] : [];
            if (paymentInstruments[1]) {
                this.state.paymentInstruments = this.state.paymentInstruments.concat(paymentInstruments[1]);
            }

            if (this.hasPaymentInstrumentsForMethod(this.state.paymentInstruments) === true) {
                this.goToPaymentInstruments(keepSelectedPaymentInstrument);
            } else {
                this.goToSelectedAccordion(ACCORDION_CARDS.PAYMENT_AMOUNT);
            }
            this.state.paymentDetailsUrl = '';
        });
        this.getPaymentInstrumentsForAllPolicies(this.state.accountNumber);
        return promiseForPayInsts;
    };

    refreshAccountsList = () => {
        const promiseForPayInsts = this.getPaymentInstruments(this.state.accountNumber);
        showProgressDialog(platformMessages.loading, promiseForPayInsts, true, 0);
        promiseForPayInsts.then((pms) => {
            let instruments = [];
            if (this.state.usePaymentusAch) {
                instruments = instruments.concat(pms);
            } else {
                if (pms[0]) {
                    instruments = instruments.concat(pms[0]);
                }
                if (pms[1]) {
                    instruments = instruments.concat(pms[1]);
                }
            }
            this.state.paymentInstruments = instruments;
        });
        return promiseForPayInsts;
    };

    createBankAccountPaymentInstrument = () => {
        const { bundledPaymentRequest } = this.state;
        const paymentDetails = {};
        paymentDetails.bankAccountDetails = this.state.bankAccountDetails.value;
        paymentDetails.last4Digits = this.state.bankAccountDetails.accountNumber.value.length > 3 ? this.state.bankAccountDetails.accountNumber.value.slice(-4) : this.state.bankAccountDetails.accountNumber.value;
        paymentDetails.bankName = BOA_BANK_NAME;
        paymentDetails.policyNumber = this.state.bundledPaymentRequest.paymentRequests.value[0].policyNumber;
        const promiseForBankAccount = MLPaymentService.createOneTimeBankAccountInstrument(paymentDetails, true, this.props.authHeader);

        showProgressDialog(platformMessages.loading, promiseForBankAccount);

        promiseForBankAccount.then((newInstrumentId) => {
            const newPaymentRequestsValue = bundledPaymentRequest.paymentRequests.value.map((item) => ({
                ...item,
                selectedPaymentInstrument_ML: newInstrumentId
            }));
            const newBundledPaymentRequestValue = _.set(bundledPaymentRequest, 'paymentRequests.value', newPaymentRequestsValue);
            this.setState({
                bundledPaymentRequest: newBundledPaymentRequestValue
            });

            setTimeout(() => {
                this.refreshPaymentInstruments(true)
                    .then(() => {
                        this.setState((preState) => ({
                            selectedPaymentInstrument:
                                {
                                    value: preState.paymentInstruments.find((instrument) => {
                                        return instrument.token === newInstrumentId;
                                    })
                                }
                        }));
                    });
            }, BANK_REFRESH_DELAY);
        });
    };

    updateBankAccountPaymentInstrument = () => {
        const promiseForBankAccount = MLPaymentService.updateBankAccountDetails(
            this.state.bankAccountDetails.value,
            this.state.accountNumber,
            true,
            this.props.authHeader
        );

        const removePortalUnavailableInstrument = (oldInstrumentId, newInstrumentId) => {
            if (oldInstrumentId !== newInstrumentId && this.state.paymentInstruments) {
                const index = this.state.paymentInstruments.findIndex((instrument) => {
                    return instrument.token === oldInstrumentId;
                });
                if (index > -1) {
                    this.state.paymentInstruments.splice(index, 1);
                }
            }
        };

        showProgressDialog(platformMessages.loading, promiseForBankAccount);

        promiseForBankAccount.then((instrumentId) => {
            setTimeout(() => {
                this.refreshPaymentInstruments().then((pms) => {
                    const bankInstruments = this.state.usePaymentusAch ? pms : pms[0];
                    removePortalUnavailableInstrument(this.state.bankAccountDetails.value.publicID, instrumentId);
                    if (instrumentId) {
                        this.setSelectedPaymentInstrument(bankInstruments, instrumentId);
                    } else {
                        this.state.selectedPaymentInstrument.value = null;
                    }
                });
            }, BANK_REFRESH_DELAY);
        });
    };

    saveBankAccountPaymentInstrument = () => {
        if (this.state.bankAccountDetails.publicID.value) {
            this.updateBankAccountPaymentInstrument();
        } else {
            this.createBankAccountPaymentInstrument();
        }
    };

    // ==================== JPMC Integration (START) ==================== //

    showEditPaymentInstrumentIframe = (accountToken, paymentInstrumentType) => {
        const promiseForIframeUrl = MLGatewayAccountBillingDetailsService.editPaymentInstrument(
            this.state.accountNumber,
            accountToken,
            `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
            paymentInstrumentType,
            this.props.authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForIframeUrl);

        promiseForIframeUrl.then((iframeUrl) => {
            this.state.showPaymentusIframe = true;
            this.setState({ paymentDetailsUrl: iframeUrl });
        });
    };

    editBankAccountInstrument = (accountToken) => {
        const promiseForGetBankAccountDetails = MLPaymentService.getBankAccountDetails(
            accountToken,
            this.state.accountNumber,
            true,
            this.props.authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForGetBankAccountDetails);

        promiseForGetBankAccountDetails.then((details) => {
            for (const prop in details) {
                if (details.hasOwnProperty(prop)) {
                    this.state.bankAccountDetails.value[prop] = details[prop];
                }
            }
            this.state.bankAccountDetails.confirmAccountNumber = this.state.bankAccountDetails.accountNumber;
            this.refreshData();
        });
    };

    editPaymentInstrument = (accountToken) => {
        this.resetPaymentError();
        this.goToPaymentInstrumentDetails();
        if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD) {
            this.showEditPaymentInstrumentIframe(accountToken, 'CC');
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT) {
            if (this.state.usePaymentusAch) {
                this.showEditPaymentInstrumentIframe(accountToken, 'DD');
            } else {
                this.editBankAccountInstrument(accountToken);
            }
        }
    };

    deletePaymentusAccount = (paymentInstrument) => {
        const promiseForDeleteAccount = MLGatewayAccountBillingDetailsService.deletePaymentInstrument(
            this.state.accountNumber,
            paymentInstrument.token,
            this.props.authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForDeleteAccount);

        promiseForDeleteAccount.then(() => {
            this.state.deletedPaymentInstrument = paymentInstrument;
            setTimeout(async () => {
                let instruments = [];
                showProgressDialog(platformMessages.loading);
                const pms = await this.getPaymentInstruments(this.state.accountNumber).finally(() => {
                    hideProgressDialog(platformMessages.loading);
                });

                if (this.state.usePaymentusAch) {
                    instruments = instruments.concat(pms);
                } else {
                    if (pms[0]) {
                        instruments = instruments.concat(pms[0]);
                    }
                    if (pms[1]) {
                        instruments = instruments.concat(pms[1]);
                    }
                }
                instruments.forEach((instr) => {
                    instr.isOnPaymentPage = true;
                });
                await this.setState({paymentInstruments: instruments});

                if (!this.state.paymentInstruments.some((instrument) => instrument === this.state.selectedPaymentInstrument.value)) {
                    this.resetPaymentInstrument();
                }
                if (this.state.selectedPaymentInstrument.value === null && this.hasPaymentInstrumentsForMethod(this.state.paymentInstruments) === true) {
                    this.defaultPaymentInstrument(this.state.selectedPaymentMethod.value);
                }
            }, CC_REFRESH_DELAY);
        });
    };

    deleteBankAccountInstrument = (paymentInstrument) => {
        const promiseForDeleteBankAccount = MLPaymentService.deleteBankAccountInstrument(
            paymentInstrument.token,
            this.state.accountNumber,
            true,
            this.props.authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForDeleteBankAccount);

        promiseForDeleteBankAccount.then((deleteFlag) => {
            if (deleteFlag) {
                this.state.deletedPaymentInstrument = paymentInstrument;
                setTimeout(() => {
                    this.refreshPaymentInstruments().then(() => {
                        if (!this.state.paymentInstruments.some((instrument) => instrument === this.state.selectedPaymentInstrument.value)) {
                            this.resetPaymentInstrument();
                        }
                        if (this.state.selectedPaymentInstrument.value === null && this.hasPaymentInstrumentsForMethod(this.state.paymentInstruments) === true) {
                            this.defaultPaymentInstrument(this.state.selectedPaymentMethod.value);
                        }
                        this.refreshData();
                    });
                }, BANK_REFRESH_DELAY);
            } else {
                showErrorModal(messages.failedToRemoveAccountHeader, messages.failedToRemoveAccountMessage);
            }
        });
    };

    deletePaymentInstrument = (paymentInstrument) => {
        if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD ||
            (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT && this.state.usePaymentusAch)) {
            this.deletePaymentusAccount(paymentInstrument);
        } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT) {
            this.deleteBankAccountInstrument(paymentInstrument);
        }
    };

    showConfirmationInfo = (res) => {
        const confirmation = {};
        confirmation.confirmations = res;
        confirmation.effectiveDate = res[0].effectiveDate;

        if (typeof (confirmation.effectiveDate) === 'object') {
            confirmation.effectiveDate = MLLocalDateUtil.localDate2Date(confirmation.effectiveDate);
        }

        if (this.state.agencySweepInfo.agencySweepIndicator.value === true) {
            confirmation.last4Digits = this.last4Digits(this.state.agencySweepInfo.accountNumber.value);
        } else {
            confirmation.last4Digits = this.state.selectedPaymentInstrument.value.last4Digits;
        }
        this.state.bundledPaymentRequest.paymentRequests.value.forEach((request) => {
            const policy = this.state.accountBillingData.find((p) => p.policyNumber_ML === request.policyNumber);
            confirmation.methodDiff = this.isDifferentPaymentMethod(request, policy);
            if (confirmation.methodDiff) {
                return false;
            }
        });

        this.props.history.push({
            pathname: 'billingConfirmation',
            state: {
                confirmation: confirmation,
                agencySweepIndicator: this.state.agencySweepInfo.agencySweepIndicator.value,
                selectedPaymentInstrument: this.state.selectedPaymentInstrument
            }
        });
    };

    makePaymentusPayment = () => {
        this.getProducerCode();
        
        const promiseForMakePayment = MLGatewayAccountBillingDetailsService.makePayment(
            this.state.bundledPaymentRequest.value,
            this.props.authHeader
        );

        showProgressDialog(messages.processingPayment, promiseForMakePayment);
        promiseForMakePayment.then((res) => {
            const declined = res.find((paymentResponse) => {
                return paymentResponse.status === 'DECL';
            });

            if (declined) {
                this.state.paymentError.paymentProcessingError = true;
            } else {
                this.showConfirmationInfo(res);
            }
        }).catch((e) => {
            if (e.baseError.indexOf("|Declined:") !== -1) {
                const messagesML = e.baseError.match(new RegExp("Messages_ML\: \\[(.*)\\]"));
                const messagesSplit = messagesML[1].split("|");
                this.state.paymentDeclinedReason = messagesSplit[1];
            }
            this.state.paymentError.paymentProcessingError = true;
            window.scrollTo(0, 0);
            this.refreshData();
        });
    };

    makeBankAccountPayment = () => {
        this.state.agencySweepInfo.agencySweepIndicator.value = false;
        this.getProducerCode();

        const paymentPromise = MLGatewayAccountBillingDetailsService.makeBankAccountPayment(
            this.state.bundledPaymentRequest.paymentRequests.value,
            this.props.authHeader
        );

        showProgressDialog(messages.processingPayment, paymentPromise);
        paymentPromise.then((res) => {
            if (res.length === 1 && res[0].reversed) {
                window.scrollTo(0, 0);
                this.state.paymentError.paymentProcessingError = true;
                this.refreshData();
            } else {
                this.showConfirmationInfo(res);
            }
        }).catch(() => {
            window.scrollTo(0, 0);
            this.state.paymentError.paymentProcessingError = true;
            this.refreshData();
        });
    };

    makeAgencySweepPayment = () => {
        this.state.agencySweepInfo.value = this.state.selectedPolicy.value.producerCodeOfServiceSweepInfo_ML;
        this.prepareAgencySweepRequests();

        const paymentPromise = MLGatewayAccountBillingDetailsService.makeAgencySweepPayment(
            this.state.bundledPaymentRequest.paymentRequests.value,
            this.props.authHeader
        );

        showProgressDialog(messages.processingPayment, paymentPromise);
        paymentPromise.then((res) => {
            this.showConfirmationInfo(res);
        }).catch(() => {
            this.state.paymentError.paymentProcessingError = true;
        });
    };

    makePayment = () => {
        if (this.isMakePaymentValid()) {
            if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.CREDIT_CARD) {
                this.makePaymentusPayment();
            } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.BANK_ACCOUNT) {
                if (this.state.selectedPaymentChannel.code === PAYMENT_CHANNELS.AGENT_IN_PERSON) {
                    this.props.history.push({
                        pathname: 'billingRequiredSignature',
                        state: {
                            bundledPaymentRequest: this.state.bundledPaymentRequest.value,
                            usePaymentusAch: this.state.usePaymentusAch,
                            paymentInstrument: this.state.selectedPaymentInstrument.value,
                            totalPaymentAmount: this.getTotalPaidAmount(),
                            isGpa: true
                        }
                    });
                } else if (this.state.usePaymentusAch) {
                    this.makePaymentusPayment();
                } else {
                    this.makeBankAccountPayment();
                }
            } else if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.AGENCY_SWEEP) {
                this.makeAgencySweepPayment();
            }
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_MakeAPayment`);
        }
    };

    getPaymentRequestProducerCode = (paymentRequest) => {
        return _.find(this.state.accountBillingData, { policyNumber_ML: paymentRequest.policyNumber }).policyDetails.producerCode_ML.code;
    };

    isDifferentPaymentMethod = (paymentRequest, policy) => {
        if (paymentRequest.paymentMethod !== policy.policyPaymentMethod_ML) {
            return true;
        }
        if (policy.policyPaymentInstrumentPublicID_ML) {
            return paymentRequest.selectedPaymentInstrument_ML !== policy.policyPaymentInstrumentPublicID_ML;
        }
        if (policy.policyPaymentInstrumentToken_ML) {
            return paymentRequest.selectedPaymentInstrument_ML !== policy.policyPaymentInstrumentToken_ML;
        }

        return false;
    };

    prepareAgencySweepRequests = () => {
        // add agency sweep related fields to each payment request
        this.state.bundledPaymentRequest.paymentRequests.value.forEach((request) => {
            request.paymentMethod = PAYMENT_METHODS.BANK_ACCOUNT;
            request.producerCode = this.getPaymentRequestProducerCode(request);
            request.isAgencySweepPayment = true;
            request.agencySweepInfo = this.state.selectedPolicy.value.producerCodeOfServiceSweepInfo_ML;
            request.customerPaymentMethod = this.state.sweepPaymentDetails.customerPaymentMethod_ML.value.code;
            request.paymentChannel_ML = PAYMENT_CHANNELS.AGENCY_SWEEP;
        });
    };

    getProducerCode = () => {
        // add Producer Code related fields to each payment request
        this.state.bundledPaymentRequest.paymentRequests.value.forEach((request) => {
            request.producerCode = this.getPaymentRequestProducerCode(request);
        });
    };

    markCreditCardForDeletion = (newPaymentInstrumentToken) => {
        const addedOneTimeCreditCard = this.state.paymentInstruments.find((instrument) => {
            return instrument.token === newPaymentInstrumentToken;
        });
        if (addedOneTimeCreditCard) {
            MLPaymentService.markOneTimePaymentCardForDeletion(this.state.accountNumber, addedOneTimeCreditCard.token, this.props.authHeader);
        }
    };

    updateExistingCreditCard = (token, pms) => {
        const pi = pms.find((instrument) => instrument.token === token);
        if (pi && pi.paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
            MLPaymentService.updateExistingCreditCardDetails(
                this.state.accountNumber,
                pi.token,
                pi.creditCardExpDate,
                pi.last4Digits,
                pi.cardholderName,
                true,
                this.props.authHeader
            );
        }
    };

    getUrlQueryParams = (url) => {
        const splitRst = url.split('?');
        const params = {};

        if (splitRst[1]) {
            let query = splitRst[1];
            query = query.split('+').join(' ');

            const re = /[?&]?([^=]+)=([^&]*)/g;
            let tokens = [];

            tokens = re.exec(query);
            while (tokens !== null && tokens.length > 2) {
                const key = decodeURIComponent(tokens[1]);
                const value = decodeURIComponent(tokens[2]);
                params[key] = value;
                tokens = re.exec(query);
            }
        }

        return params;
    };

    setHttpResponse = () => {
        let token = '';
        let url = '';
        try {
            url = document.getElementById('PaymentusIframe').contentWindow.location.href;
        } catch (error) {
            // do nothing
        }

        const params = this.getUrlQueryParams(url);
        token = params.token;

        if (params.DLAction === DL_ACTIONS.CANCEL) {
            this.setState({showPaymentusIframe: false, showPaymentInstruments: true});
        } else if (params.DLAction === DL_ACTIONS.ADD_ACOUNT || params.DLAction === DL_ACTIONS.EDIT_ACCOUNT) {
            setTimeout( async() => {
                let instruments = [];
                showProgressDialog(platformMessages.loading);
                const pms = await this.getPaymentInstruments(this.state.accountNumber).finally(() => {
                    hideProgressDialog(platformMessages.loading);
                });
                if (this.state.usePaymentusAch) {
                    instruments = instruments.concat(pms);
                } else {
                    if (pms[0]) {
                        instruments = instruments.concat(pms[0]);
                    }
                    if (pms[1]) {
                        instruments = instruments.concat(pms[1]);
                    }
                }
                instruments.forEach((paymentInstrument) => {
                    paymentInstrument.isOnPaymentPage = true;
                });
                this.setState({paymentInstruments: instruments});
                this.setState({showPaymentusIframe: false, showPaymentInstruments: true, paymentDetailsUrl: ''});

                if (token) {
                    if (params.DLAction === DL_ACTIONS.EDIT_ACCOUNT) {
                        this.updateExistingCreditCard(token, instruments);
                    }
                    if (params.DLAction === DL_ACTIONS.ADD_ACOUNT) {
                        this.markCreditCardForDeletion(token);
                    }
                    this.state.selectedPaymentInstrument.value = instruments.find((instrument) => {
                        return instrument.token === token;
                    });
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                        item.selectedPaymentInstrument_ML = this.state.selectedPaymentInstrument.value ? this.state.selectedPaymentInstrument.value.token : null;
                    });
                    this.refreshData();
                }
            }, CC_REFRESH_DELAY);
        }
    };

    // END JPMC

    isAnyPolicySelected = () => {
        if (this.state.accountBillingData) {
            return this.state.accountBillingData.some((c) => c.selected);
        }
        this.isAnyPaymentAmountNull();
        return false;
    };

    isAnyPaymentAmountNull = () => {
        return this.state.selectedAmountOption.value === null;
    };

    checkSplPreferredPaymentWarning = () => {
        this.state.showRestrictedPaymentMethodWarning = false;
        const paymentRequests = this.state.bundledPaymentRequest.paymentRequests.value;
        const selectedPaymentMethod = this.state.selectedPaymentMethod.value;
        if (this.isSplUser() && selectedPaymentMethod === 'creditcard' && !this.state.showRestrictedPaymentMethodError) {
            paymentRequests.forEach((request) => {
                if (request.productCode !== "PersonalUmbrella" &&  request.isModernProduct_Ext && request.preferredPaymentMethodInd_Ext) {
                    this.state.showRestrictedPaymentMethodWarning = true;
                }
            });
        }
    };

    componentDidMount = async () => {
        const {
            accountInfo: { accountNumber }
        } = this.props;
        this.setState({ accountNumber });

        const { authHeader } = this.props;

        this.state.bankAccountDetails.accountHolder.value = {};

        const getAccountPolicySummaries_ML = (billingData) => {
            const data = {};
            billingData.forEach((policy) => {
                data[policy.policyNumber_ML] = policy.effectiveDate_ML;
            });
            return PolicyService.getAccountPolicyDetailsByPolicyNumber_ML(data, this.props.authHeader);
        };

        MLGatewayAccountBillingDetailsService.getAccountPolicyPeriodsBillingSummary(accountNumber, authHeader).then((billingData) => {
            let filteredBillingData = this.filterBillingData(billingData);
            if ( filteredBillingData[0].hasPaymentInstrument_ML === false) {
                this.setState({ setHasPaymentInstrumentStatus: false });
            }
            else {
                this.setState({ setHasPaymentInstrumentStatus: true });
            }
            getAccountPolicySummaries_ML(filteredBillingData).then((summaryData) => {
                if (filteredBillingData.length > summaryData.length) {
                    // Removes policy billing data that belongs to other producer codes
                    filteredBillingData = filteredBillingData.filter(
                        (data) => summaryData.findIndex((summary) => summary.policyNumber === data.policyNumber_ML) !== -1);
                }
                this.setState({ accountBillingData: filteredBillingData });
                this.setState({ policySummaries: summaryData });
                this.setState({ isLoading: false });
            });
        });

        MLPortalSettingsService.getSettings(authHeader).then((settings) => {
            this.state.enableBundledOneStepPayments = settings.enablePaymentusBundledOneStep
        });
       
        

        this.getPaymentInstruments(accountNumber).then((paymentInstruments) => {
            let instruments = [];
            if (this.state.usePaymentusAch) {
                instruments = instruments.concat(paymentInstruments);
            } else {
                if (paymentInstruments[0]) {
                    instruments = instruments.concat(paymentInstruments[0]);
                }
                if (paymentInstruments[1]) {
                    instruments = instruments.concat(paymentInstruments[1]);
                }
            }
            instruments.forEach((paymentInstrument) => {
                paymentInstrument.isOnPaymentPage = true;
            });
            this.setState({ paymentInstruments: instruments });
        });

        this.setPaymentChannel();
        this.getPaymentInstrumentsForAllPolicies(accountNumber);
    }

    render() {
        const {
            isLoading,
            currentCard
        } = this.state;

        const translator = this.context;

        if (isLoading) {
            return (<></>);
        }

        const onHeaderClicked = (card) => {
           this.goToSelectedAccordion(card.name);
        };

        const renderHeader = (active, card) => {
            // Accordion
            const getAccordionNumber = () => {
                let number = 0;
                switch (card) {
                    case ACCORDION_CARDS.SELECT_POLICY:
                        number += 1;
                        break;
                    case ACCORDION_CARDS.PAYMENT_AMOUNT:
                        number += 2;
                        break;
                    case ACCORDION_CARDS.PAYMENT_METHOD:
                        number += 3;
                        break;
                    default:
                        break;
                }
                return number;
            };

            const getAccordionCardTitle = () => {
                switch (card) {
                    case ACCORDION_CARDS.SELECT_POLICY:
                        return translator(messages.selectPolicyTitle);
                    case ACCORDION_CARDS.PAYMENT_AMOUNT:
                        return translator(messages.paymentAmountTitle);
                    case ACCORDION_CARDS.PAYMENT_METHOD:
                        return translator(messages.paymentMethodTitle);
                    default:
                        return '';
                }
            };

            const showEditAction = () => {
                switch (card) {
                    case ACCORDION_CARDS.SELECT_POLICY:
                        return currentCard === ACCORDION_CARDS.PAYMENT_METHOD || currentCard === ACCORDION_CARDS.PAYMENT_AMOUNT;
                    case ACCORDION_CARDS.PAYMENT_AMOUNT:
                        return currentCard === ACCORDION_CARDS.PAYMENT_METHOD;
                    default:
                        return false;
                }
            };

            const index = getAccordionNumber();
            return (
                <div className="ml-payment-header">
                    <div className="ml-payment-header__main-content">
                        <span className={classNames('ml-count-icon ml-panel-set__item-indicator large static', { active: active })}>
                            {index}
                        </span>

                        <div className="ml-panel-set__item-title">
                            {getAccordionCardTitle()}
                            {showEditAction() && (
                                <Button className="ml-panel-set__item-edit-cta" mlTagManagerLinkClick={card === ACCORDION_CARDS.PAYMENT_METHOD ? "Account Summary_MakeAPayment_PaymentMethod_Next" : undefined}>{translator(messages.edit)}</Button>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const trackIntermediarySteps = (nextCard) => {
            if (nextCard === ACCORDION_CARDS.INSTRUMENT_SELECTION) {
                if (!this.state.selectedPaymentMethod || !this.state.selectedPaymentInstrument) {
                    this.setState(
                        { selectedPaymentMethod: { value: null } },
                        { selectedPaymentInstrument: { value: null } }
                    );
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                        item.selectedPaymentInstrument_ML = null;
                    });
                }
            }
        };

        const goToNextAccordion = async ({ card, nextCard }) => {
            const isCardComponentValid = this.isChildComponentValid(card);
            // updateShowErrors(isCardComponentValid === false);

            if (isCardComponentValid) {
                if (nextCard === ACCORDION_CARDS.PAYMENT_METHOD) {
                    let instruments = [];
                    showProgressDialog(platformMessages.loading);
                    const pms = await this.getPaymentInstruments(this.state.accountNumber).finally(() => {
                        hideProgressDialog(platformMessages.loading);
                    });

                    if (this.state.usePaymentusAch) {
                        instruments = instruments.concat(pms);
                    } else {
                        if (pms[0]) {
                            instruments = instruments.concat(pms[0]);
                        }
                        if (pms[1]) {
                            instruments = instruments.concat(pms[1]);
                        }
                    }
                    instruments.forEach((paymentInstrument) => {
                        paymentInstrument.isOnPaymentPage = true;
                    });
                    this.setState({paymentInstruments: instruments});
                }
                trackIntermediarySteps(nextCard);
                this.setState({ currentCard: nextCard });
            }
        };
        // Accordion End

        // Payment Method Card

        const getValidPaymentMethods = () => {
            const methods = [];
            methods.push({
                id: PAYMENT_METHODS.CREDIT_CARD,
                displayName: translator(messages.creditDebitCard)
            });

            if (this.showBankAccountOption()) {
                methods.push({
                    id: PAYMENT_METHODS.BANK_ACCOUNT,
                    displayName: translator(messages.bankAccount)
                });
            }
            if (this.showAgencySweepOption()) {
                methods.push({
                    id: PAYMENT_METHODS.AGENCY_SWEEP,
                    displayName: translator(messages.agencySweep)
                });
            }
            return methods;
        };

        const authorizationScriptTime = () => {
            const currentTime = new Date();
            const transitionTime = new Date();
            transitionTime.setHours(16, 30, 0, 0);

            let script = 'today';

            if (currentTime > transitionTime) {
                script = 'tomorrow';
            }

            return script;
        };

        const onPaymentMethodChange = (value) => {
            const amount = this.getTotalPaidAmount().amount;
            this.state.showDownpaymentScriptCheckbox = false;
            this.updateCheckboxValue(false);
            this.state.paymentError.lessThanMinCardAmountError = amount < 1 && value === PAYMENT_METHODS.CREDIT_CARD;

            const setAgencySweepIndicator = () => {
                if (this.state.selectedPaymentMethod.value === PAYMENT_METHODS.AGENCY_SWEEP) {
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                        item.isAgencySweepPayment = true;
                        item.customerPaymentMethod = _.get(this.state.sweepPaymentDetails, 'customerPaymentMethod_ML.value.code');
                        this.state.showAgencySweepDetails = true;
                    });
                } else {
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                        item.isAgencySweepPayment = false;
                        item.customerPaymentMethod = null;
                        this.state.showAgencySweepDetails = false;
                    });
                }
            };

            this.state.selectedPaymentMethod.value = value;
            this.state.bundledPaymentRequest.paymentRequests.value.forEach((item) => {
                item.paymentMethod = value;
                item.isPaymentChannelRequired_ML = this.isPaymentChannelRequired();
            });
            this.state.showRestrictedPaymentMethodError = false;
            this.setPaymentChannel();
            this.goToPaymentInstruments();
            setAgencySweepIndicator();
            if (value === PAYMENT_METHODS.BANK_ACCOUNT && !this.state.showBankAccountDetails && !this.state.showPaymentusIframe && this.hasPaymentInstrumentsForMethod()) {
                this.defaultPaymentInstrument(PAYMENT_METHODS.BANK_ACCOUNT);
            } else if (value === PAYMENT_METHODS.CREDIT_CARD && !this.state.showPaymentusIframe && this.hasPaymentInstrumentsForMethod()) {
                this.defaultPaymentInstrument(PAYMENT_METHODS.CREDIT_CARD);
            }

            this.checkSplPreferredPaymentWarning();
            this.refreshData();

            if (value === 'creditcard' && this.state.isAgentScripts) {
                this.getCardDownpaymentScript(amount);
                this.state.showDownpaymentScriptCheckbox = true;
            } else if (value === 'ach' && this.state.isAgentScripts) {
                this.getAccountDownpaymentScript(amount, this.state.selectedPaymentInstrument?.value?.last4Digits);
                this.state.showDownpaymentScriptCheckbox = true;
            }
        };

        const getValidPaymentChannels = () => {
            const channels = [];
            channels.push({
                id: PAYMENT_CHANNELS.AGENT_IN_PERSON,
                displayName: translator(messages.agentInPerson)
            });
            channels.push({
                id: PAYMENT_CHANNELS.AGENT_PHONE,
                displayName: translator(messages.agentPhone)
            });
            return channels;
        };

        const onPaymentChannelChange = (value) => {
            this.state.selectedPaymentChannel.code = value;
            this.setPaymentChannel();

            this.refreshData();
        };

        const onPaymentInstrumentChange = (paymentInstrument) => {
            this.state.showRestrictedPaymentMethodError = false;

            const accountType = paymentInstrument.accountType_ML;
            if (NON_PREFERRED_PAYMENT_METHODS.includes(accountType)) {
                const paymentRequests = this.state.bundledPaymentRequest.paymentRequests.value;
                paymentRequests.forEach((request) => {
                    if (request.productCode !== "PersonalUmbrella" && request.isModernProduct_Ext && request.preferredPaymentMethodInd_Ext) {
                        this.state.showRestrictedPaymentMethodError = true;
                    }
                });
            }

            this.checkSplPreferredPaymentWarning();
            this.state.showDownpaymentScriptCheckbox = false;
            this.updateCheckboxValue(false);
            this.state.selectedPaymentInstrument.value = paymentInstrument;
            this.refreshData();

            if (paymentInstrument.paymentMethod === 'creditcard' && this.state.isAgentScripts) {
                this.getCardDownpaymentScript(this.getTotalPaidAmount().amount);
                this.state.showDownpaymentScriptCheckbox = true;
            } else if (paymentInstrument.paymentMethod === 'ach' && this.state.isAgentScripts) {
                this.getAccountDownpaymentScript(this.getTotalPaidAmount().amount, this.state.selectedPaymentInstrument.value.last4Digits);
                this.state.showDownpaymentScriptCheckbox = true;
            }
        };

        const sendTagManagerEvent = (_label) => {
            const change = _label ? `Make Changes_${_label}` : 'UpdatePaymentOption';
            const formName = MLTagManagerService.getFormName() === MLTagManagerService.getStepName() ?
                `${MLTagManagerService.getStepName()}_${change}` :
                `${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${change}`;
            MLTagManagerService.sendFormStartEvent(formName);
        };
        const onLinkClick = (event, policyNumber, index) => {
            console.log(policyNumber);
            sendTagManagerEvent(`/billing-details`, undefined);
            event.preventDefault();
            MLNavigationStepsTrackingService.init('PolicyChange', this.state.policySummaries[index].product.publicID, translator);
            const { lobEndorsementURL, endorsementProducts } = appConfig;
            const redirectpath = `/billing-details`;
            if (endorsementProducts.includes(this.state.policySummaries[index].product.publicID)) {
                this.props.history.push(lobEndorsementURL[this.state.policySummaries[index].product.publicID], { policyNumber: policyNumber,chosenStepPathML: redirectpath});
            }
        };

        const mlcustomInlineNotification = ({className,...rest}) => {
            return this.state.billingDatas.map((element, index) => {
                return <div className={className} {...rest}><strong>Action needed</strong>. Payment details for policy {element.policyNumber_ML} are missing or need updating. Please click on <Link onClick={(evt) => onLinkClick(evt, element.policyNumber_ML, index)} style={{"text-decoration":"none"}}>Update Payment Options</Link> to update your policy as soon as possible to keep it in good standing.</div>
            });
        };

        // Payment Methond Card End

        const generateCardClasses = () => {
            const getClassName = (card) => {
                if (card === currentCard) {
                    return 'ml-panel-set__item active';
                }
                return 'ml-panel-set__item';
            };

            const getIsCollapsible = (card) => {
                switch (card) {
                    case ACCORDION_CARDS.SELECT_POLICY:
                        return currentCard !== ACCORDION_CARDS.SELECT_POLICY;
                    case ACCORDION_CARDS.PAYMENT_AMOUNT:
                        return currentCard === ACCORDION_CARDS.PAYMENT_METHOD;
                    case ACCORDION_CARDS.PAYMENT_METHOD:
                        return false;
                    default:
                        return true;
                }
            };

            const overrides = Object.values(ACCORDION_CARDS).map((value) => {
                return {
                    [`${value}`]: {
                        className: getClassName(value),
                        isCollapsible: getIsCollapsible(value)
                    }
                };
            });

            return Object.assign({}, ...overrides);
        };        

        const overrides = {
            updatingpaymentoptions: {
                visible: !(this.state.setHasPaymentInstrumentStatus)
            },
            accordionContainer: {
                accordionStates: [currentCard]
            },
            selectPolicyNextDescription: {
                content: (
                    <FormattedMessage
                        {...messages.selectPolicyNextDescription}
                        values={{
                            onetimePaymentAmount: (
                                <strong>{translator(messages.onetimePaymentAmount)}</strong>
                            )
                        }}
                    />
                )
            },
            selectPolicyNextButton: {
                disabled: !this.isAnyPolicySelected()
            },
            policyAmountNextDescription: {
                content: (
                    <FormattedMessage
                        {...messages.policyAmountNextDescription}
                        values={{
                            paymentMethod: (
                                <strong>{translator(messages.paymentMethod)}</strong>
                            )
                        }}
                    />
                )
            },
            policyAmountNextButton: {
                disabled: this.isAnyPaymentAmountNull() || !this.isChildComponentValid(ACCORDION_CARDS.PAYMENT_AMOUNT)
            },
            nextDescription: {
                content: (
                    this.isShowOneTimePaymentNext()
                        ? (
                            <FormattedMessage
                                {...messages.wellGetRequiredSignaturesNext}
                                values={{
                                    getRequiredSignatures: (
                                        <strong>{translator(messages.getRequiredSignatures)}</strong>
                                    )
                                }}
                            />
                        )
                        : (
                            <FormattedMessage
                                {...messages.wellProcessYourPaymentNext}
                                values={{
                                    processYourPayment: (
                                        <strong>{translator(messages.processYourPayment)}</strong>
                                    )
                                }}
                            />
                        )
                )
            },
            selectPolicyToPayComponent: {
                policySummaries: this.state.policySummaries || [],
                policiesBillingData: this.state.accountBillingData || [],
                bundledPaymentRequest: this.state.bundledPaymentRequest,
                isGpa: true,
                unsetSelectedPolicy: (policy) => {
                    if (policy.pendingPayment_ML) {
                        this.state.pendingPaymentPolicies.delete(policy);
                    }
                    this.setState({ selectedPolicy: { value: undefined } });
                },
                setSelectedPolicy: (policy) => {
                    if (policy.pendingPayment_ML) {
                        this.state.pendingPaymentPolicies.add(policy);
                    }
                    this.setState({ selectedPolicy: { value: _.get(policy, 'policyDetails') } });
                },
                checkSplPreferredPaymentWarning: this.checkSplPreferredPaymentWarning
            },
            selectPaymentAmountComponent: {
                policiesBillingData: this.state.accountBillingData || [],
                paymentRequests: this.state.bundledPaymentRequest.paymentRequests,
                selectedAmountOption: this.state.selectedAmountOption || { value: null },
                isGpa: true,
                onUpdatePaymentAmount: this.refreshData
            },
            paymentMethodOptions: {
                availableValues: getValidPaymentMethods(),
                onValueChange: onPaymentMethodChange,
                value: this.state.selectedPaymentMethod.value
            },
            paymentChannelOptionsRow: {
                visible: this.isPaymentChannelRequired()
            },
            paymentChannelOptions: {
                availableValues: getValidPaymentChannels(),
                onValueChange: onPaymentChannelChange,
                value: this.state.selectedPaymentChannel.code
            },
            paymentusIframe: {
                id: 'PaymentusIframe',
                src: this.state.paymentDetailsUrl,
                className: 'PaymentusPaymentDetailsFrame',
                onLoad: this.setHttpResponse,
                visible: this.state.showPaymentusIframe
            },
            bankAccountDetailsComponent: {
                visible: this.state.showBankAccountDetails,
                bankAccountDetails: this.state.bankAccountDetails,
                onModelChange: this.refreshData,
                onSave: this.saveBankAccountPaymentInstrument,
                onCancel: this.goToPaymentInstruments,
                showErrorPopup: true,
                showCancel: true
            },
            agencySweepComponent: {
                visible: this.state.showAgencySweepDetails,
                paymentDetails: this.state.sweepPaymentDetails,
                sweepInfo: _.get(this.state.selectedPolicy, 'value.producerCodeOfServiceSweepInfo_ML'),
                onModelChange: (paymentDetails) => {
                    this.state.bundledPaymentRequest.paymentRequests.value.forEach((request) => {
                        request.customerPaymentMethod = _.get(paymentDetails.customerPaymentMethod_ML, 'value.code');
                    });
                    this.refreshData();
                }
            },
            paymentInstrumentsRow: {
                visible: this.state.showPaymentInstruments
            },
            selectPaymentMethodComponent: {
                paymentMethod: this.state.selectedPaymentMethod,
                paymentInstruments: this.state.paymentInstruments,
                paymentInstrumentsForAllPolicies: this.state.paymentInstrumentsForAllPolicies,
                paymentRequests: this.state.bundledPaymentRequest.paymentRequests,
                selectedPaymentInstrument: this.state.selectedPaymentInstrument,
                onPaymentInstrumentChange: onPaymentInstrumentChange,
                editPaymentInstrument: this.editPaymentInstrument,
                deletePaymentInstrument: this.deletePaymentInstrument,
                onInvalidCreditCard: () => { this.state.paymentError.invalidCreditCardError = true; },
                hasPaymentError: this.hasPaymentError,
                resetPaymentError: this.resetPaymentError,
                addPaymentInstrument: this.addPaymentInstrument,
                isGpa: true,
                usePaymentus: this.state.usePaymentusAch,
                showRestrictedPaymentMethodError: this.state.showRestrictedPaymentMethodError,
                showRestrictedPaymentMethodWarning: this.state.showRestrictedPaymentMethodWarning
            },
            pendingPaymentAlert: {
                // visible: this.state.pendingPaymentPolicies.size > 0,
                visible: false,
                message: (<strong>{translator(messages.pendingPaymentWarning)}</strong>)
            },
            paymentErrorAlert: {
                visible: this.hasPaymentError()
            },
            paymentProcessingErrorAlert: {
                visible: this.state.paymentError.paymentProcessingError,
                message: (
                    <FormattedMessage
                        {...messages.paymentProcessingError}
                        values={{
                            notSuccess: (
                                <><strong>{translator(messages.notSuccess, { amount: this.formatAmountString(this.getTotalPaidAmount()) })}</strong><br />{_.get(this.state, 'paymentDeclinedReason')}<br /></>
                            )
                        }}
                    />
                )
            },
            invalidCreditCardError: {
                visible: this.state.paymentError.invalidCreditCardError,
                message: (<strong>{translator(messages.invalidCreditCardError)}</strong>)
            },
            lessThanMinCardAmountError: {
                visible: this.state.paymentError.lessThanMinCardAmountError,
                message: (<strong>{translator(messages.lessThanMinCardAmountError)}</strong>)
            },
            deletedPaymentInstrumentAlert: {
                visible: !!this.state.deletedPaymentInstrument,
                message: (
                    <FormattedMessage
                        {...messages.removeInstrumentSuccess}
                        values={{
                            xEndingInX: (
                                <strong>{translator(messages.xEndingInX, { nickname: _.get(this.state, 'deletedPaymentInstrument.nickname'), last4Digits: _.get(this.state, 'deletedPaymentInstrument.last4Digits') })}</strong>
                            )
                        }}
                    />
                )
            },
            scriptCheckboxField: {
                value: this.state.isChecked,
                visible: this.showScript() && this.showCheckbox(),
                onValueChange: this.updateCheckboxValue,
            },
            nextButton: {
                disabled: !this.isMakePaymentValid() || this.state.showPaymentusIframe || this.state.showBankAccountDetails ||
                    (this.showCheckbox() && !this.state.isChecked) || this.state.showRestrictedPaymentMethodError
            },
            mlScriptComponent: {
                mlScript: this.state.scriptML,
                visible: this.showScript()
            },

            ...generateCardClasses()
        };
        const resolvers = {
            resolveComponentMap: {
                selectpolicytopaycomponent: MLSelectPolicyToPayComponent,
                selectpaymentamountcomponent: MLSelectPaymentAmountComponent,
                selectpaymentmethodcomponent: MLSelectPaymentMethodComponent,
                bankaccountdetailscomponent: MLBankAccountDetailsComponent,
                agencysweepcomponent: MLAgencySweepComponent,
                mlScriptComponent: MLScriptComponent,
                mlcustomInlineNotification
            },
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                goToNextAccordion,
                renderHeader,
                onHeaderClicked,
                makePayment: this.makePayment
            }
        };
        const billingPage = <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
        return (
            <div>
                {billingPage}
            </div>
        );
    }
}

const MLAccountBilling = withModalContext(MLAccountBillingWithoutModalContext);

export const AccountBillingComponent = MLAccountBilling;
export default withRouter(withViewModelService(withAuthenticationContext(MLAccountBilling)));
